export default function CsNetworkingBasics() {
  return (
    <h2>Cs Networking Basics</h2>
  );
}
